import Card from './Card';

export interface WorkExperienceProps {
    title: string;
    companyName: string;
    department: string;
    companyURL: string;
    workYears: string;
    tasks: Array<string>;
    technologies: string[];
    companyLogo?: string;
}

const WorkExperience = (props: WorkExperienceProps) => {
    const techText = props.technologies.join(' • ');

    return (
        <Card
            icon={
                props.companyLogo ? (
                    <img src={props.companyLogo} alt={props.companyName} className="company-logo" />
                ) : (
                    <i className="icon bi-asterisk"></i>
                )
            }
        >
            <h4 className="title">
                {props.title}
                <br />
                <a href={props.companyURL}>{props.companyName}</a>
            </h4>
            <p className="description m-0">
                <strong>{props.workYears}</strong> • {props.department}
            </p>
            <ul className="task-list">
                {props.tasks.map((task, index) => (
                    <li key={index}>{task}</li>
                ))}
            </ul>
            <p className="description m-0">
                <strong>Tech Stack:</strong> {techText}
            </p>
        </Card>
    );
};

export default WorkExperience;
